export default __webpack_public_path__ + "static/media/main.e3eeb391.gif";